import { ReactElement } from "react";

interface props {
  icon: ReactElement;
  label: string;
  value?: string;
}
export default function ReadOnlyField({ icon, label, value }: props) {
  return (
    <dl className="ml-4 text-ldir-brown-900 mb-2">
      <div className="flex text-xl items-start gap-2">
        {icon}
        <dt>{label}</dt>
      </div>
      <dd className="text-xl ml-8 font-bold">{value}</dd>
    </dl>
  );
}
